import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DocumentParams } from '../../customer/documents/enums/enum';
declare var $: any;
@Component({
  selector: 'zest-file-upload-picker',
  templateUrl: './file-upload-picker.component.html',
  styleUrls: ['./file-upload-picker.component.scss']
})
export class FileUploadPickerComponent implements OnInit {

  public id: string;
  public smallText: string;
  public largeText: string;
  public accept: string;
  public buttonText: string;
  public labelButton = false;

  public passwordRequired = false;
  public docPassword = '';
  public receivedDoc: any = null;
  public fileToSave: any = null;
  public documentSrc: any = null;
  public errorMessage: string;
  public passwordValidated = true;
  public viewPassword = false;
  public firstAttemptWithoutPassword = true;
  public isPDF = false;
  public isImg = false;
  public processing = false;
  public loadingFile = false;

  @Input() labelId: string;
  @Input() labelSmallText: string;
  @Input() labelLargeText: string;
  @Input() fileType: string;
  @Input() labelButtonText: string;
  @Input() previewRequired: boolean;
  @Input() imageFilesAllowed: boolean;
  @Input() pdfFilesAllowed: boolean;
  @Input() fileLimitMinSize: number;
  @Input() fileLimitMaxSize: number;

  @Output() selectFileEvent = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.id = this.labelId;
    this.smallText = this.labelSmallText;
    this.largeText = this.labelLargeText;
    this.buttonText = this.labelButtonText;
    this.accept = this.fileType;
    if (this.labelButtonText) {
      this.labelButton = true;
    }
    const inputFileElement = document.getElementsByTagName('input')[0];
    inputFileElement.onclick = function () {
      inputFileElement.value = null;
    };
    this.initializeDocumentViewer();
  }
  selectFile($event) {
    this.initializeDocumentViewer();
    this.receivedDoc = $event;
    this.fileToSave = $event.target.files[0];
    let minSize = 0;
    let maxSize = DocumentParams.fileSize15Mb;
    if (this.fileLimitMaxSize && this.fileLimitMinSize) {
      minSize = this.fileLimitMinSize;
      maxSize = this.fileLimitMaxSize;
    }
    if (!this.previewRequired) {
      this.receivedDoc['fileToSave'] = this.fileToSave;
      this.selectFileEvent.emit($event);
    } else {
      if (
        !(this.pdfFilesAllowed === false) &&
        (DocumentParams.pdfFileFormat.indexOf(this.fileToSave.type) > -1) &&
        this.fileToSave.size > minSize &&
        this.fileToSave.size < maxSize) {
        this.isPDF = true;
        this.isImg = false;
        this.previewPDF($event, null);
      } else if (
        this.imageFilesAllowed &&
        (DocumentParams.imageFileFormats.indexOf(this.fileToSave.type) > -1) &&
        this.fileToSave.size > minSize &&
        this.fileToSave.size < maxSize
      ) {
        this.isPDF = false;
        this.isImg = true;
        this.previewImages($event);
      } else {
        this.receivedDoc['fileToSave'] = this.fileToSave;
        this.selectFileEvent.emit($event);
      }
    }
  }
  initializeDocumentViewer() {
    this.documentSrc = null;
    this.receivedDoc = null;
    this.passwordRequired = false;
    this.docPassword = '';
    this.errorMessage = '';
    this.passwordValidated = true;
    this.viewPassword = false;
    this.firstAttemptWithoutPassword = true;
    this.fileToSave = null;
    this.isPDF = false;
    this.isImg = false;
    this.processing = false;
    this.loadingFile = false;
    setTimeout(fn => {
      $('#documentPreviewModal.modal').modal();
    }, 0);
  }
  clearInput(event) {
    event.target.value = '';
  }
  closeModal() {
    const fileReceiver: HTMLInputElement = <HTMLInputElement>document.querySelector('.inputfile');
    fileReceiver.value = '';
    setTimeout(fn => {
      $('#documentPreviewModal').modal('close');
      this.initializeDocumentViewer();
    }, 0);
  }
  upload() {
    if (this.receivedDoc) {
      this.receivedDoc['documentPassword'] = this.docPassword;
      this.receivedDoc['fileToSave'] = this.fileToSave;
      this.selectFileEvent.emit(this.receivedDoc);
    }
    this.closeModal();
  }
  previewImages(imageFile: any) {
    this.errorMessage = '';
    this.documentSrc = null;
    this.loadingFile = true;
    setTimeout(fn => {
      $('#documentPreviewModal').modal('open');
    }, 0);
    if (imageFile.target.files && imageFile.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.documentSrc = event.target.result;
        this.loadingFile = false;
      };
      reader.readAsDataURL(imageFile.target.files[0]);
    }
  }
  previewPDF(file: any, passwordReceived: string = null) {
    this.processing = true;
    this.errorMessage = '';
    this.docPassword = passwordReceived;
    this.documentSrc = null;
    setTimeout(fn => {
      $('#documentPreviewModal').modal('open');
    }, 0);
    if (typeof (FileReader) !== 'undefined') {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.documentSrc = { url: URL.createObjectURL(file.target.files[0]), password: passwordReceived };
      };
      reader.readAsArrayBuffer(file.target.files[0]);
    }
  }
  validatePasswordInput(event: any) {
    if (!this.docPassword) {
      this.errorMessage = 'The document requires a password to be opened.';
    } else {
      this.errorMessage = '';
    }
  }
  onError(event) {
    if (event.name === 'PasswordException') {
      this.passwordRequired = true;
      this.passwordValidated = false;
      this.docPassword = '';
      this.documentSrc = null;
      if (event.message === 'No password given') {
        if (!this.firstAttemptWithoutPassword) {
          this.errorMessage = 'The document requires a password to be opened.';
        } else {
          this.firstAttemptWithoutPassword = !this.firstAttemptWithoutPassword;
        }
      } else {
        this.errorMessage = event.message;
      }
    }
    this.processing = false;
  }
  pdfLoadingComplete(pdf) {
    this.passwordValidated = true;
    this.processing = false;
  }
  fetchDocumentPassword() {
    this.passwordValidated = true;
    this.previewPDF(this.receivedDoc, this.docPassword);
  }

}
